/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description React Hook useDeleteProvider
 */

import { useMutation, useQueryClient, UseMutationResult } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import { invalidateMetadata } from 'app-constants/queryKeys';

/**
 * Mutate for Delete Provider
 *
 */
const useDeleteProvider = (): UseMutationResult<unknown, IAxiosError, { providerId: string }, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ providerId }) => {
			await api.ProvidersApi.deleteProvider({ providerId });
		},
		onSuccess: () => {
			AppEvents.publishApiSuccess();
			invalidateMetadata(queryClient);
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useDeleteProvider;
